import{FlexStyle as e}from"@kui-shared/flex";var t=e;import{FlexDefaults as n}from"@kui-shared/flex";var l={Inline:"kui-inline"},i={...n,direction:"row",gap:"none"};export{i as InlineDefaults,t as InlineStyle,l as InlineTestIDs};
